<template>
    <div>
        <!-- visiting this page will first require you to login and based on your role you will see either of the two below -->
        <!-- for admins: see event list and view registrations. Registrations can be approved or declined, approval sends user id as qrcode to user email as event pass ticket -->
        <!-- for staff: they will see event list and click start checkin and will be able to see event checkin component -->
        <event-management></event-management>
    </div>
</template>

<script>
    import EventManagement from '../../components/admin/EventManagement.vue';
export default {
    components:{
        EventManagement
    }
}
</script>